module.exports = __webpack_public_path__ + "static/media/istanbul.92bb8868.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/istanbul.jpg
// module id = 39
// module chunks = 0